import {
  CreateOrUpdateJobConfigurationDto,
  CreateOrUpdateJobConfigurationDtoTypeEnum,
  JobConfigurationDto,
  JobFrequency,
} from '@/api/generator';

export function toCreateOrUpdateJobConfigurationDto(
  dto: JobConfigurationDto,
): CreateOrUpdateJobConfigurationDto {
  return {
    ...dto,
    assignedRoles: dto.assignedRoles?.map((role) => role.id),
    assignedUsers: dto.assignedUsers?.map((user) => user.id),
    reviewRoles: dto.reviewRoles?.map((role) => role.id),
    reviewUsers: dto.reviewUsers?.map((user) => user.id),
    targetSystemId: dto.targetSystem?.id,
    $type:
      CreateOrUpdateJobConfigurationDtoTypeEnum.PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoCreateOrUpdateJobConfigurationDtoPtwPtw100AppZeroApplicationShared,
  };
}

// Weekdays only apply to Daily; for other frequencies the backend returns whatever was stored (usually `[]`).
export function toJobConfigurationFormValues(dto: JobConfigurationDto): JobConfigurationDto {
  const { schedule } = dto;

  if (!schedule || schedule.frequency === JobFrequency.Daily) {
    return dto;
  }

  return { ...dto, schedule: { ...schedule, weekdays: undefined } };
}
